import { isValid } from "date-fns";
import React from "react";

import { TSurveyModel } from "@performyard/models";
import { AvatarProfile, Text } from "@performyard/py-components";

import FormattedDateTime from "../../../../../components/FormattedDateTime";
import Link from "../../../../../components/Link";

export const getDateCell = (date: Date | null) => {
	if (!date || !isValid(date)) {
		return null;
	}

	return (
		<FormattedDateTime
			date={date}
			dateSize="large"
			hasTime={false}
			size="paragraph-3"
			weight="regular"
			element="span"
		/>
	);
};

export const getSurveyNameCell = (survey: TSurveyModel) => {
	const { name, status } = survey;
	const tab = status === "draft" ? "build" : "results";
	return (
		<Link testId="survey-link" href={`/surveys/${survey._id}?tab=${tab}`}>
			<Text size="paragraph-3" weight="regular" dangerouslySetClassName="py-line-clamp-1">
				{name}
			</Text>
		</Link>
	);
};

export const getEmployeeNameCell = (employee: { _id: string; name: string } | null) => {
	if (!employee) {
		return null;
	}

	return <AvatarProfile employeeId={employee._id} employeeName={employee.name} />;
};
